import axios from "axios";

import { BASE_URL } from "./Constants";

export const getBoletim = async (ra, authCode, period) => {
	let data = JSON.stringify({
		period: period,
		ra: ra,
        code: authCode,
	});

	let config = {
		method: "post",
		maxBodyLength: Infinity,
		url: BASE_URL + "boletim",
		headers: {
			"Content-Type": "application/json",
		},
		data: data,
	};

    if (ra == "test") {
        let boletim = {
            'personal': {
                'name': 'Nome do Aluno', 
                'ra': '000000000', 
                'course': 'ADM', 
                'class': 'Creators A', 
                'year': '2025', 
                'semester': '1', 
                'warning': 0, 
                'suspension': 0, 
                'brand_ambassador': true, 
                'represent': true, 
                'profile': 'ENFJ-T - Diplomata | Protagonista'
            }, 
            'international_affairs': {
                'programs': ['lodge_boston', 'lodge_madrid', 'lodge_palo_alto', 'madrid', 'disney', 'babson', 'stanford', 'wharton', 'china'], 'highlights': []
            }, 
            'grades': {
                'general': {
                    'grade': 9.0, 
                    'freq': 91.8, 
                    'rank': 3
                }, 
                "showAol": true,
                "showNp": true,
                'grades_by_subject': {
                    'IA for Business': {
                        'np1_grade': 10, 
                        'a1_grade': 10, 
                        'aol_grade': 5,
                        'np2_grade': 7,
                        'a2_grade': 8.2, 
                        'final_grade': 9.1, 
                        'classroom_avg': 8.33, 
                        'freq': 91, 
                        'approved': true
                    }, 
                    'Estratégia ': {
                        'np1_grade': 8.9,
                        'a1_grade': 8.9,
                        'aol_grade': 5,
                        'np2_grade': 8.2,
                        'a2_grade': 8.2, 
                        'final_grade': 8.5, 
                        'classroom_avg': 7.38, 
                        'freq': 90, 
                        'approved': true
                    }, 
                    'Finanças - Tópicos Especiais de Contabilidade e Finanças': {
                        'np1_grade': 8.7,
                        'a1_grade': 8.7, 
                        'aol_grade': 0,
                        'np2_grade': 8.2,
                        'a2_grade': 8.2,
                        'final_grade': 8.4, 
                        'classroom_avg': 7.57, 
                        'freq': 96, 
                        'approved': true
                    }, 
                    'Fundraising ': {
                        'np1_grade': 10,
                        'a1_grade': 10,
                        'aol_grade': '-',
                        'np2_grade': 10,
                        'a2_grade': 10, 
                        'final_grade': 10, 
                        'classroom_avg': 7.68, 
                        'freq': 86, 
                        'approved': true
                    }, 
                    'Sales & Growth - Escalando a Receita': {
                        'np1_grade': 9.5,
                        'a1_grade': 9.5, 
                        'aol_grade': 7.5,
                        'np2_grade': 8.2,
                        'a2_grade': 8.2, 
                        'final_grade': 9, 
                        'classroom_avg': 7.76, 
                        'freq': 96, 
                        'approved': true
                    }
                }
            },
            'practical_challenge': {
                'group': 'Raiders',
                'challenge': 'Desafio V',
                'grades': [
                    { 
                        'skill': "Trabalho em equipe", 
                        'grade': 4, 
                        'class_grade': 3 
                    },
                    { 
                        'skill': "Liderança", 
                        'grade': 3, 
                        'class_grade': 4 
                    },
                    { 
                        'skill': "Comunicação", 
                        'grade': 2, 
                        'class_grade': 5 
                    },
                    { 
                        'skill': "Iniciativa", 
                        'grade': 5, 
                        'class_grade': 2 
                    },
                    { 
                        'skill': "Organização", 
                        'grade': 3, 
                        'class_grade': 5 
                    }
                ]
            },
            'extra_activities': {
                'horas_cumpridas': 148, 
                'horas_faltantes': 160
            }, 
            'show_internship': true, 
            'internship': {
                'final_grade': 8.5, 
                'max_grade': 10, 
                'approved': true, 
                'grades': [
                    {
                        'title': 'Documentação', 
                        'grade': 5.0, 
                        'max_grade': 5
                    }, 
                    {
                        'title': 'Relatório', 
                        'grade': 3.5, 
                        'max_grade': 5
                    }
                ]
            }, 
            'english': {
                'final_grade': 4.0, 
                'max_grade': 6, 
                'status': 'APPROVED', 
                'grades': [
                    {
                        'title': 'Listening', 
                        'grade': 4.29, 
                        'max_grade': 6
                    }, 
                    {
                        'title': 'Grammar', 
                        'grade': 3.79, 
                        'max_grade': 6
                    }, 
                    {
                        'title': 'Writing', 
                        'grade': 4.2, 
                        'max_grade': 6
                    }, 
                    {
                        'title': 'Speaking', 
                        'grade': 3.85, 
                        'max_grade': 6
                    }
                ]
            }, 
            'link_labs': [
                {
                    'type': 'comunidade',
                    'labs': 25, 
                    'total': 50
                },
                {
                    'type': 'conhecimento',
                    'labs': 42, 
                    'total': 53
                },
                {
                    'type': 'visita',
                    'labs': 10, 
                    'total': 32
                }
            ], 
            'student_success': {
                'mentoria': {
                    'final_grade': 5.0, 
                    'max_grade': 5, 
                    'status': 'Pendente'
                },
                'workshop_fast_track': [
                    {
                        'title': 'Plano de Carreira',
                        'check': true
                    },
                    {
                        'title': 'Plano de Ação',
                        'check': true
                    },
                    {
                        'title': 'Gestão de Tempo',
                        'check': false
                    }
                ],
                'workshop': [
                    {
                        'title': 'Currículo',
                        'check': true
                    },
                    {
                        'title': 'Entrevista',
                        'check': false
                    }
                ]
            },
            'communities': ['tech', 'finance', 'real_estate'],
            'communities_leader': ['tech'], 
            'sports': ['basquete', 'tenis'], 
            'link_pulse': {
                'empresa': 'Nome da Empresa', 
                'funcao': 'Fundador', 
                'setor': 'Setor da Empresa', 
                'estagio_negocio': 'Tração', 
                'faturamento': 'R$85,000.00', 
                'captou': 'Sim, venda de equity'
            }, 
            'startup_school': {
                'final_grade': 5.0, 
                'max_grade': 5, 
                'approved': true, 
                'grades': [
                    {
                        'title': 'Participação', 
                        'grade': 5.0, 
                        'max_grade': 5
                    }, 
                    {
                        'title': 'Trabalho em Equipe', 
                        'grade': 5.0, 
                        'max_grade': 5
                    }, 
                    {
                        'title': 'Cliente', 
                        'grade': 4.0, 
                        'max_grade': 5
                    }, 
                    {
                        'title': 'Faturamento', 
                        'grade': 4.0, 
                        'max_grade': 5
                    }
                ]
            },
            'ventures': ['startup', 'mi5', 'demoday'],
            'nivelamentos': ['matematica']
        }

        let _grades_by_subject = []
        for (const [key, value] of Object.entries(boletim.grades.grades_by_subject)) {
            _grades_by_subject.push({
                subject: key,
                ...value
            })
        }

        boletim.grades.grades_by_subject = _grades_by_subject;

        return boletim;
    }

	const boletim = await axios
		.request(config)
		.then((response) => {
			const { boletim } = response.data;

            let _grades_by_subject = []
            for (const [key, value] of Object.entries(boletim.grades.grades_by_subject)) {
                _grades_by_subject.push({
                    subject: key,
                    ...value
                })
            }

            boletim.grades.grades_by_subject = _grades_by_subject;

			return boletim;
		})

	return boletim;
};
